import React from 'react';

const EmptyState = ({
    title = 'No Data Found',
    message = 'There are no records available at this moment.',
    icon = 'fa-folder-open',
    actionText,
    onAction,
    actionHref
}) => {
    return (
        <div className="d-flex flex-column align-items-center justify-content-center text-center p-5 my-4 w-100 bg-light rounded border">
            <div className="mb-3 text-muted">
                <i className={`fa ${icon} fa-3x`} style={{ opacity: 0.6 }}></i>
            </div>
            <h4 className="text-dark mb-2">{title}</h4>
            <p className="text-muted mb-4" style={{ maxWidth: '450px' }}>{message}</p>
            {actionText && actionHref && (
                <a href={actionHref} className="btn btn-primary btn-sm">
                    {actionText}
                </a>
            )}
            {actionText && onAction && !actionHref && (
                <button type="button" className="btn btn-primary btn-sm" onClick={onAction}>
                    {actionText}
                </button>
            )}
        </div>
    );
};

export default EmptyState;

